import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, ShieldCheck, ChevronDown, Lock } from 'lucide-react';
import { Button, Section } from './Shared';
import { trackFb } from '../lib/fbpixel';
export function Pricing() {
  return <Section id="pricing" className="relative" data-id="element-54">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-brand-gold/5 via-brand-dark to-brand-dark -z-10" data-id="element-55" />

      <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-56">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-5 leading-tight" data-id="element-57">
          Si siempre sentiste que había algo más detrás de la historia oficial,{' '}
          <span className="text-brand-gold" data-id="element-58">
            esta colección fue hecha para vos.
          </span>
        </h2>
        <p className="text-brand-muted text-base md:text-lg" data-id="element-59">
          Entrá hoy a la Colección NOS MIENTEN y accedé a una experiencia
          documental premium, diseñada para quienes quieren ir más allá de las
          versiones incompletas, los resúmenes superficiales y las explicaciones
          cómodas.
        </p>
      </div>

      <div className="max-w-md mx-auto bg-gradient-to-b from-[#1c1813] via-brand-anthracite to-brand-anthracite rounded-2xl border border-brand-gold/60 shadow-[0_0_60px_rgba(197,160,89,0.25)] overflow-hidden relative" data-id="element-60">
        <div className="bg-gradient-to-r from-brand-gold via-brand-goldLight to-brand-gold text-brand-dark text-center py-2.5 text-xs font-bold tracking-[0.2em] uppercase" data-id="element-61">
          Oferta Especial de Lanzamiento
        </div>

        {/* Mockup sutil de la colección */}
        <div className="px-6 pt-6 pb-2" data-id="element-62">
          <div className="relative rounded-lg overflow-hidden border border-brand-gold/20 bg-brand-dark max-w-[260px] mx-auto" data-id="element-63">
            <img src="https://cdn.magicpatterns.com/uploads/3xV3KEMfNKP6BhhhrRPwUE/ChatGPT_Image_26_jun_2026,_20_42_04.png" alt="Colección completa NOS MIENTEN: 6 volúmenes y 3 bonos" className="w-full h-auto object-contain" data-id="element-64" />
            <div className="absolute inset-0 pointer-events-none ring-1 ring-inset ring-brand-gold/10 rounded-lg" data-id="element-65" />
          </div>
        </div>

        <div className="p-8 pt-5" data-id="element-66">
          <div className="text-center mb-8" data-id="element-67">
            <p className="text-brand-muted text-sm mb-1" data-id="element-68">
              Valor total del pack:
            </p>
            <p className="text-brand-muted/50 line-through text-lg mb-4" data-id="element-69">
              $97.937
            </p>

            <p className="text-brand-gold/90 text-sm font-bold uppercase tracking-wider mb-2" data-id="element-70">
              Precio de lanzamiento hoy:
            </p>
            <div className="text-5xl md:text-6xl font-serif font-bold text-transparent bg-clip-text bg-gradient-to-b from-brand-goldLight to-brand-gold mb-2 drop-shadow-[0_2px_12px_rgba(197,160,89,0.35)]" data-id="element-71">
              $21.990
            </div>
          </div>

          <div className="bg-brand-dark rounded-xl p-5 mb-8 border border-brand-gold/25" data-id="element-72">
            <p className="text-brand-gold font-bold text-sm mb-4 border-b border-brand-gold/20 pb-2 tracking-wide uppercase" data-id="element-73">
              Esto incluye hoy:
            </p>
            <ul className="space-y-3" data-id="element-74">
              {['NOS MIENTEN: El Archivo de los No Contactados', '6 volúmenes principales', 'Bono 1: El Libro Negro de los Misterios Modernos', 'Bono 2: Los Archivos Desclasificados', 'Bono 3: Las Grandes Civilizaciones Perdidas'].map((item, idx) => <li key={idx} className="flex items-start gap-3 text-sm text-brand-offWhite" data-id="element-75">
                  <Check className="w-4 h-4 text-brand-gold shrink-0 mt-0.5" data-id="element-76" />
                  <span data-id="element-77">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="space-y-2 mb-8" data-id="element-78">
            {['Acceso inmediato', 'Formato 100% digital', '3 bonos incluidos', 'Compatible con celular, tablet y PC'].map((item, idx) => <div key={idx} className="flex items-center justify-center gap-2 text-xs text-brand-muted" data-id="element-79">
                <ShieldCheck className="w-3 h-3 text-brand-gold" data-id="element-80" />
                <span data-id="element-81">{item}</span>
              </div>)}
          </div>

          <Button fullWidth className="text-lg py-5" onClick={() => {
          trackFb('InitiateCheckout', {
            content_name: 'Colección NOS MIENTEN',
            content_type: 'product',
            currency: 'ARS',
            value: 27990
          });
          trackFb('Lead', {
            content_name: 'Colección NOS MIENTEN'
          });
          window.open('https://nos-mienten.impultienda.ar/checkout', '_blank', 'noopener,noreferrer');
        }} data-id="element-82">
            QUIERO OBTENER EL ACCESO
          </Button>

          <p className="text-center text-brand-red text-xs font-bold mt-4 uppercase tracking-wider" data-id="element-83">
            Oferta de lanzamiento disponible por tiempo limitado
          </p>
          <p className="text-center text-brand-muted text-[10px] mt-2" data-id="element-84">
            Pago único • Acceso inmediato • Lectura en todos tus dispositivos
          </p>
        </div>
      </div>
    </Section>;
}
export function Guarantee() {
  return <Section darker data-id="element-85">
      <div className="max-w-2xl mx-auto text-center bg-brand-anthracite p-8 md:p-12 rounded-2xl border border-brand-card" data-id="element-86">
        <ShieldCheck className="w-12 h-12 text-brand-gold mx-auto mb-6" data-id="element-87" />
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-88">
          Entrá al archivo sin riesgo
        </h2>
        <p className="text-brand-muted text-base leading-relaxed" data-id="element-89">
          Si al acceder sentís que esta colección no tiene la profundidad, el
          impacto o el valor que esperabas, podés revisar la garantía disponible
          dentro del plazo correspondiente. Queremos que entres con confianza.
        </p>
      </div>
    </Section>;
}
const faqs = [{
  q: '¿En qué formato se entrega?',
  a: 'En formato PDF digital de alta calidad.'
}, {
  q: '¿Lo recibo al instante?',
  a: 'Sí. El acceso es inmediato después de completar la compra.'
}, {
  q: '¿Puedo leerlo desde el celular?',
  a: 'Sí. Podés leerlo desde celular, tablet, notebook o PC.'
}, {
  q: '¿Incluye los bonos?',
  a: 'Sí. Los 3 bonos mencionados están incluidos en esta oferta.'
}, {
  q: '¿Incluye Antártida y Los Evangelios Perdidos?',
  a: 'No. Esas investigaciones especiales se desbloquean después de la compra con una oferta exclusiva para compradores.'
}, {
  q: '¿Es contenido básico o profundo?',
  a: 'Está diseñado para ser claro, visual y profundo, ideal para lectores curiosos y fanáticos del tema.'
}];
export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);
  return <Section data-id="element-90">
      <div className="max-w-3xl mx-auto" data-id="element-91">
        <h2 className="text-2xl md:text-4xl font-bold text-white text-center mb-10" data-id="element-92">
          Preguntas Frecuentes
        </h2>
        <div className="space-y-3" data-id="element-93">
          {faqs.map((faq, idx) => <div key={idx} className="bg-brand-dark border border-brand-card rounded-lg overflow-hidden" data-id="element-94">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full px-6 py-4 flex items-center justify-between text-left focus:outline-none" data-id="element-95">
                <span className="font-medium text-white text-sm md:text-base" data-id="element-96">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-gold transition-transform duration-300 ${openIdx === idx ? 'rotate-180' : ''}`} data-id="element-97" />
              </button>
              <AnimatePresence data-id="element-98">
                {openIdx === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-99">
                    <div className="px-6 pb-4 text-brand-muted text-sm border-t border-brand-card/50 pt-4" data-id="element-100">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </Section>;
}
export function FinalCTA() {
  return <Section darker className="relative overflow-hidden !py-14 md:!py-16" data-id="element-101">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-brand-gold/10 via-brand-dark to-brand-dark -z-10" data-id="element-102" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-103">
        <Lock className="w-8 h-8 text-brand-gold mx-auto mb-6 opacity-50" data-id="element-104" />
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-105">
          El archivo está abierto.{' '}
          <span className="text-brand-gold" data-id="element-106">La decisión es tuya.</span>
        </h2>
        <p className="text-lg md:text-xl text-brand-muted mb-10 max-w-2xl mx-auto" data-id="element-107">
          Accedé hoy a la Colección NOS MIENTEN con precio especial de
          lanzamiento, acceso inmediato y los 3 bonos incluidos.
        </p>
        <Button onClick={() => {
        trackFb('AddToCart', {
          content_name: 'Colección NOS MIENTEN',
          currency: 'ARS',
          value: 27990
        });
        document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        });
      }} className="text-lg py-5 px-10" data-id="element-108">
          QUIERO ACCEDER AHORA
        </Button>
      </div>
    </Section>;
}